"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DemandPartnerMenuComponent = void 0;
const core_1 = require("@angular/core");
const $ = require("jquery");
const demand_partner_menu_service_1 = require("./demand-partner-menu.service");
const permission_service_1 = require("./permission.service");
const demand_partner_service_1 = require("./demand-partner.service");
const version_service_1 = require("./version.service");
const notification_service_1 = require("./notification.service");
const version_pipe_1 = require("./version.pipe");
const events_1 = require("./events");
const ad_unit_service_1 = require("./ad-unit.service");
let DemandPartnerMenuComponent = class DemandPartnerMenuComponent {
    constructor(modalService, el, _permission, _demandPartner, _af, _v, _version, _talk, _adUnits) {
        this.modalService = modalService;
        this.el = el;
        this._permission = _permission;
        this._demandPartner = _demandPartner;
        this._af = _af;
        this._v = _v;
        this._version = _version;
        this._talk = _talk;
        this._adUnits = _adUnits;
        this.demandPartnerOnAdd = new core_1.EventEmitter();
        this.menuFilter = ['server', 'client'];
        this.select = { client: true, server: true };
        this.demandPartnerSelected = false;
        this.build();
    }
    build() {
        this.element = $(this.el.nativeElement);
        this.permission = this._permission.get();
        this.menuList = this._demandPartner.get().filter((dp) => this.canIncludeAdapter(dp));
        this.version = { adEngine: this._v.getBiddrPlusVersion(), prebidVersion: null, generator: this._v.getApplicationVersion(), controlCenter: this._v.getControlCenterVersion() };
    }
    canIncludeAdapter(partner) {
        if (this.permission['dashboard-data_source--biddr---view_all_demand_partners'])
            return true;
        else
            return !!this.permission['include-adapter--' + partner.code];
    }
    ngOnInit() {
        let modal = this;
        this.element = $(this.el.nativeElement);
        // ensure id attribute exists
        if (!this.id) {
            console.error('modal must have an id');
            return;
        }
        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        this.element.appendTo('body');
        // close modal on background click
        this.element.on('click', function (e) {
            let target = $(e.target);
            //if (!target.closest('.modal-body').length) {
            //	modal.close();
            //}
        });
        // add self (this modal instance) to the modal service so it's accessible from controllers
        Promise.resolve(this.modalService.add(this)).then(r => {
            this.close();
        });
    }
    // remove self from modal service when directive is destroyed
    ngOnDestroy() {
        this.modalService.remove(this.id);
        this.element.remove();
    }
    // open modal
    open() {
        return Promise.resolve(this.build()).then(res => {
            if (!this.permission['control_center-view_demand_partners--server--on-ad-units'] && this.container && (typeof this.container.code == "string")) {
                this.menuFilter = ['client'];
            }
            else if (this.container && typeof this.container.code == "undefined") {
                this.menuFilter = ['server'];
                this.menuList = this.menuList.filter(dpList => {
                    for (let existingDPs in this.container) {
                        if (this.container[existingDPs].id == dpList.id) {
                            return false;
                        }
                    }
                    return true;
                });
            }
            this.element.show();
            $('#custom-modal-1').css('display', 'block');
            $('body').addClass('modal-open');
            this._af.tick();
        });
    }
    // close modal
    close() {
        this.element.hide();
        $('#custom-modal-1').css('display', 'none');
        $('body').removeClass('modal-open');
    }
    filterMenu(filter) {
        let findFilter = this.menuFilter.indexOf(filter);
        if (findFilter > -1) {
            this.menuFilter.splice(findFilter, 1);
        }
        else {
            this.menuFilter.push(filter);
        }
        this.select[filter] = !this.select[filter];
    }
    setParams(dpBeingAdded) {
        this.demandPartnerSelected = !this.demandPartnerSelected;
        this.partnerSelected = JSON.parse(JSON.stringify(dpBeingAdded));
    }
    addDemandPartnerToUnit(dpBeingAdded) {
        let dp = JSON.parse(JSON.stringify(dpBeingAdded));
        Promise.resolve(this.checkFields(dp)).then(r => {
            if (r) {
                this._talk.broadcast(`<ul [innerHTML]="modelWarnings"></ul> Please correct the following issues:\n` + r);
                return Promise.resolve(false);
            }
            this.demandPartnerSelected = !this.demandPartnerSelected;
            this.container.showDemandPartnerMenu = false;
            let placeToAdd = (dpBeingAdded.type.type == "client" || this.permission['control_center-view_demand_partners--server--on-ad-units']) ?
                this.container.demandPartners[dpBeingAdded.type.type] :
                this.container;
            let oldDP = placeToAdd.filter(existingDP => {
                return ((existingDP.displayName == dp.displayName) && (existingDP.enabled == true));
            });
            if (oldDP && oldDP.length > 0) {
                oldDP[0].enabled = true;
                oldDP[0].dpNum = 1;
            }
            for (let availDP in this.menuList) {
                if (this.menuList[availDP].id == dp.id) {
                    for (var field in dp.fields) {
                        if (typeof dp.fields == 'string') {
                            dp.fields[field].value = dp.fields[field].value.trim();
                        }
                    }
                    placeToAdd.push({
                        params: dp.params,
                        enabled: true,
                        displayName: dp.displayName,
                        code: dp.code,
                        minVersion: dp.minVersion,
                        maxVersion: dp.maxVersion,
                        logo: dp.logo,
                        id: dp.id,
                        dpNum: this.findDpNum(dp.displayName, placeToAdd.filter(dp => {
                            return dp.enabled == true;
                        })) + 1,
                        createdAt: dp.createdAt,
                        updatedAt: dp.updatedAt,
                        fields: dp.fields,
                        type: dp.type,
                        gdpr: dp.gdpr,
                        tcf2: dp.tcf2,
                        ccpa: dp.ccpa,
                        schain: dp.schain,
                        expanded: false
                    });
                    break;
                }
            }
            this.demandPartnerOnAdd.emit(dpBeingAdded);
            this.checkBidCPMAdjustmentsOnAdd(dpBeingAdded);
            this._af.tick();
            if (dpBeingAdded.type && dpBeingAdded.type.type && dpBeingAdded.type.type == "client") {
                let dPArray = $("#demandPartnerArray" + this.ucFirst(dpBeingAdded.type.type) + this.pos);
                dPArray.animate({
                    scrollLeft: dPArray[0].scrollWidth
                }, 300);
            }
            this.events.add({
                subFeature: events_1.EventSubFeature.demandPartner,
                subject: dpBeingAdded.displayName,
                subjectID: dpBeingAdded.id,
                action: events_1.EventAction.added
            });
            let dpIdx = (placeToAdd && placeToAdd.length - 1);
            dp.enabled = true;
            this.close();
        });
    }
    checkBidCPMAdjustmentsOnAdd(dP) {
        let demandPartner = JSON.parse(JSON.stringify(dP));
        let found = false;
        for (let cpm in this.bidCPMAdjustments) {
            if ((demandPartner.code == this.bidCPMAdjustments[cpm].code) && (demandPartner.type.type == this.bidCPMAdjustments[cpm].type.type)) {
                found = true;
                break;
            }
        }
        if (!found) {
            this.bidCPMAdjustments.push({ name: demandPartner.displayName || demandPartner.code, code: demandPartner.code, logo: demandPartner.logo, type: demandPartner.type, value: demandPartner.value || 100 });
        }
    }
    findDpNum(name, demandPartners) {
        let count = 0;
        for (let demandPartner in demandPartners) {
            if (name == demandPartners[demandPartner].displayName && demandPartners[demandPartner].enabled === true) {
                count++;
            }
        }
        return count;
    }
    ucFirst(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    checkFields(dp) {
        let modalWarnings = "";
        let unfilled = 0;
        for (let field in dp.fields) {
            if (dp.fields[field].value != '') {
                unfilled++;
            }
        }
        if (unfilled > 0) {
            let vFields = this._version.transform(dp.fields, this.version.adEngine);
            for (let field in vFields) {
                if (vFields[field].required || vFields[field].value) {
                    if (!vFields[field].value) {
                        modalWarnings += `<li>Demand Partner "` + dp.displayName + `" is missing a required field ` + vFields[field].name + `</li>`;
                    }
                    else {
                        switch (vFields[field].type) {
                            case "numeric":
                                if (parseFloat(vFields[field].value) != vFields[field].value) {
                                    modalWarnings += `<li>Demand Partner "` + dp.displayName + `" had a field ` + vFields[field].name + ` that should be a number but is not</li>`;
                                }
                                break;
                            case "object":
                                try {
                                    if (typeof JSON.parse(vFields[field].value) !== 'object') {
                                        modalWarnings += `<li>Demand Partner "` + dp.displayName + `" had a field ` + vFields[field].name + ` that should be an object{} but is not</li>`;
                                    }
                                }
                                catch (error) {
                                    modalWarnings += `<li>Demand Partner "` + dp.displayName + `" had a field ` + vFields[field].name + ` that should be an object{} but is not</li>`;
                                }
                                break;
                            case "array":
                                try {
                                    JSON.parse(vFields[field].value);
                                }
                                catch (e) {
                                    modalWarnings += `<li> "` + dp.displayName + `" had a field ` + vFields[field].name + ` that should be an array[] of ` + vFields[field].subType + ` but is not</li>`;
                                    break;
                                }
                                const arrVal = JSON.parse(vFields[field].value);
                                if (!Array.isArray(arrVal) || !(arrVal.length || arrVal.length > 0)) {
                                    modalWarnings += `<li> "` + dp.displayName + `" had a field ` + vFields[field].name + ` that should be an array[] but is not</li>`;
                                }
                                else {
                                    for (let val in arrVal) {
                                        switch (vFields[field].subType) {
                                            case "numeric":
                                                if (parseFloat(arrVal[val]) != arrVal[val]) {
                                                    modalWarnings += `<li> "` + dp.displayName + `" had a field ` + vFields[field].name + ` that should be a number but is not</li>`;
                                                }
                                                break;
                                            case "string":
                                                if (typeof (arrVal[val]) != 'string') {
                                                    modalWarnings += `<li> "` + dp.displayName + `" had a field ` + vFields[field].name + ` that should be a string but is not</li>`;
                                                }
                                                break;
                                            case "object":
                                                try {
                                                    if (typeof JSON.parse(vFields[field].value) !== 'object') {
                                                        modalWarnings += `<li>Demand Partner "` + dp.displayName + `" had a field ` + vFields[field].name + ` that should be an object{} but is not</li>`;
                                                    }
                                                }
                                                catch (error) {
                                                    modalWarnings += `<li>Demand Partner "` + dp.displayName + `" had a field ` + vFields[field].name + ` that should be an object{} but is not</li>`;
                                                }
                                                break;
                                        }
                                    }
                                }
                                break;
                            case "boolean":
                                if ((vFields[field].value) != "true" && (vFields[field].value) != "false") {
                                    modalWarnings += `<li>Demand Partner "` + dp.displayName + `" had a field ` + vFields[field].name + ` that should be a boolean but is not</li>`;
                                }
                                break;
                        }
                    }
                }
            }
        }
        return modalWarnings;
    }
};
exports.DemandPartnerMenuComponent = DemandPartnerMenuComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], DemandPartnerMenuComponent.prototype, "id", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], DemandPartnerMenuComponent.prototype, "demandPartnerOnAdd", void 0);
exports.DemandPartnerMenuComponent = DemandPartnerMenuComponent = __decorate([
    (0, core_1.Component)({
        moduleId: 'demand-partner-selector',
        selector: 'demand-partner-menu',
        template: `
		<div class="custom-modal">
      		<div class="modal-body container-fluid">
				<div class="demandPartnerMenuFilters" *ngIf="permission&&(permission['control_center-view_demand_partners--server--on-ad-units'])&&container&&container.code">
					Sort By:<br>
          			<span class="fa-stack clickable" (click)="filterMenu('client')">
						<i class="fa fa-square fa-stack-2x brtBlue" *ngIf="select.client"></i>
						<i class="fa fa-list fa-stack-1x brtIconColor" [ngClass]="{'brtBlue':!select.client,'brtIconColor':select.client}"></i>
					</span>
			    	<span class="fa-stack clickable" (click)="filterMenu('server')">
						<i class="fa fa-square fa-stack-2x brtBlue" *ngIf="select.server"></i>
						<i class="fa fa-cloud fa-stack-1x" [ngClass]="{'brtBlue':!select.server,'brtIconColor':select.server}"></i>
					</span>
				</div>
				<div *ngIf="!demandPartnerSelected">
					<div class="h3 text-center">Pick a Demand Partner...</div>
					<div class="demandPartnerList topPad30">  
						<div class="demandPartnerNone" *ngIf="(menuList| searchObjectKeyWithArray:'type':'type':menuFilter| version:version.adEngine).length<1">There are no Demand Partners available</div>
            <div class="clickable" *ngFor="let demandPartnerOpt of menuList| searchObjectKeyWithArray:'type':'type':menuFilter| version:version.adEngine |orderBy:['displayName']; let dp=index;" id="demandPartner-{{dp}}" (click)="setParams(demandPartnerOpt)" >
              <img src="images/logos/{{demandPartnerOpt.logo}}" onerror="this.src='images/logos/defaultLogo.png'" title="{{demandPartnerOpt.displayName}}"/>
							<span class="fa-stack demandPartner-typeIcon brtBlueBack">
								<i class="fa fa-square fa-stack-2x brtBlue"></i>
								<i class="fa fa-stack-1x brtIconColor" [ngClass]="{'fa-cloud':demandPartnerOpt.type.type=='server','fa-list':demandPartnerOpt.type.type=='client'}"></i>
								<div class="schainBadge" *ngIf="permission&&(permission['control_center-schain_supported_demand_partners'])&&demandPartnerOpt.schain">Schain</div>
								<div class="gdprBadge" *ngIf="demandPartnerOpt.gdpr">GDPR</div>
								<div class="ccpaBadge" *ngIf="permission&&(permission['control_center-demand_partner--view_ccpa_status'])&&demandPartnerOpt.ccpa">CCPA</div>
								<div class="tcf2Badge" *ngIf="permission&&(permission['control_center-demand_partner--view_tcf2_status'])&&demandPartnerOpt.tcf2">TCF2</div>
							</span>
						</div>
					</div>
				</div>
				<div *ngIf="demandPartnerSelected" class="container-fluid">
					<div class="container-fluid demandPartnerMenuParams">
              			<div class="pull-left clickable left-shark" title="Back to Menu" (click)="demandPartnerSelected=!demandPartnerSelected">
							<i class="fa fa-arrow-left fa-2x"></i>
              			</div>
						<div class="pull-right clickable right-shark" title="Add Partner"(click)="addDemandPartnerToUnit(partnerSelected)">
              				<i class="fa fa-check fa-3x brtBlue"></i>
              			</div>
              			<div class="formBuffer">
							<img src="images/logos/{{partnerSelected.logo}}" onerror="this.src='images/logos/defaultLogo.png'" title="{{partnerSelected.displayName}}" class="demandPartnerImage">
             			</div>
						<div class="row formBuffer">
							<myDemandPartnerParam class="col-xs-6 row formBuffer" [field]="field" (click)="$event.stopPropagation()" *ngFor="let field of partnerSelected.fields|version:version.adEngine"></myDemandPartnerParam>
              			</div>
					</div>
				</div>
				<div class="custom-modal-close clickable" (click)="close('custom-modal-1');"><i class="fa fa-times" aria-hidden="true"></i></div>
			</div>
		</div>
  		<div class="modal-background" (click)="close('custom-modal-1');"></div>
	`
    }),
    __metadata("design:paramtypes", [demand_partner_menu_service_1.DemandPartnerMenuService,
        core_1.ElementRef,
        permission_service_1.PermissionService,
        demand_partner_service_1.DemandPartnerService,
        core_1.ApplicationRef,
        version_service_1.VersionService,
        version_pipe_1.VersionPipe,
        notification_service_1.NotificationService,
        ad_unit_service_1.AdUnitService])
], DemandPartnerMenuComponent);
//# sourceMappingURL=demand-partner-menu.component.js.map